import { useState } from "react";
import DemoModal from "./DemoModal";

const FreeAIDemoButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <button
        onClick={handleButtonClick}
        className="relative inline-flex h-12 w-48 items-center justify-center rounded-full 
        text-black bg-white text-lg font-semibold transition-all duration-300 
        hover:scale-105 hover:shadow-[0_4px_20px_rgba(239,142,56,0.5)] active:scale-95"
      >
        Free AI Consultation
      </button>
      {isModalOpen && <DemoModal setIsModalOpen={setIsModalOpen} />}
    </>
  );
};

export default FreeAIDemoButton;
